<script>
export default {
    name: 'Rate',
    props: {
        value: null,
        display: Boolean,
        lg: Boolean,
    },
    data() {
        return {
            hover: null,
        }
    },
    methods: {
        onClick(val, e) {
            if (!this.display) {
                e.stopPropagation()
                this.$emit('input', val)
            }
        },
        setHover(val, e) {
            if (!this.display) {
                e.stopPropagation()
                if (this.hover !== val) this.hover = val
            }
        },
    },
}
</script>

<template lang="pug">
.rate(:class="lg ? 'font-size-26': 'font-size-m'")
    span.rate-star(v-for="index in 10"
        :class="[(index <= value && hover === null) || (index <= hover && hover !== null)  ? 'text-yellow' : 'text-cc', {'rate-star-lg': lg}]"
        @mouseover="setHover(index, $event)"
        @mouseleave="setHover(null, $event)"
        @click="onClick(index, $event)"
        :key="`ratingIcon-${index}`")
            svg(v-if="index % 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512")
                path(v-if="(index <= value && hover === null) || (index <= hover && hover !== null)" fill="currentColor" d="M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z")
                path(v-else fill="currentColor" d="M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z")
            svg.fa-flip-horizontal(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" v-else)
                path(v-if="(index <= value && hover === null) || (index <= hover && hover !== null)" fill="currentColor" d="M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z")
                path(v-else fill="currentColor" d="M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z")
</template>
